import styled from "@emotion/styled"
import SectionWrapper from "../../components/section-wrapper/section-wrapper.component"
import CustomImage from "../../components/custom-image/custom-image.component"
import { Container, Typography } from "@mui/material"
import { TypeAnimation } from "react-type-animation"
import CustomBgImage from "../../components/custom-bg-image/custom-bg-image.component"
import CustomButton from "../../components/custom-button/custom-button.component"

export const Section = styled(SectionWrapper)`
  padding-top: 0;
  padding-bottom: 0;
  overflow: hidden;
  position: relative;

  ${({ theme }) => theme.breakpoints.down("sm")} {
    height: 950px;
  }

  ${({ theme }) => theme.breakpoints.up("md")} {
    height: var(--viewport-height, 100vh);
    min-height: 800px;
  }
`

export const BgImage = styled(CustomBgImage)`
  /* position: absolute;
  top: 0;
  width: 100%;
  z-index: 1;

  img {
    height: var(--viewport-height, 100vh);
    width: 100%;
    object-fit: cover !important;
  }

  ${({ theme }) => theme.breakpoints.down("sm")} {
    height: 950px;
    img {
      height: 950px;
    }
  }

  ${({ theme }) => theme.breakpoints.down("md")} {
    height: 700px;
  }

  ${({ theme }) => theme.breakpoints.up("md")} {
    height: var(--viewport-height, 100vh);
    min-height: 800px;
  } */
`

export const Wrapper = styled(Container)`
  z-index: 2;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  ${({ theme }) => theme.breakpoints.down("sm")} {
    justify-content: flex-start;
    padding-top: ${({ theme }) => theme.typography.pxToRem(155)};
    min-height: 950px;

    .MuiButtonBase-root {
      z-index: 3;
    }
  }

  ${({ theme }) => theme.breakpoints.down("md")} {
    height: 700px;
  }

  ${({ theme }) => theme.breakpoints.up("md")} {
    height: var(--viewport-height, 100vh);
    min-height: 800px;
  }
`

export const TopTitle = styled(Typography)`
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: ${({ theme }) => theme.typography.pxToRem(40)};
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: ${({ theme }) => theme.typography.pxToRem(18)};

  ${({ theme }) => theme.breakpoints.down("md")} {
    font-size: ${({ theme }) => theme.typography.pxToRem(30)};
    margin-bottom: ${({ theme }) => theme.typography.pxToRem(8)};
    font-weight: 500;
  }
`

export const Title = styled(Typography)`
  color: ${({ theme }) => theme.palette.primary.light};
  font-size: ${({ theme }) => theme.typography.pxToRem(72)};
  font-style: normal;
  font-weight: 400;
  line-height: ${({ theme }) => theme.typography.pxToRem(80)};
  margin-bottom: ${({ theme }) => theme.typography.pxToRem(48)};
`

export const Description = styled(Typography)`
  color: ${({ theme }) => theme.palette.primary.light};
  font-size: ${({ theme }) => theme.typography.pxToRem(18)};
  font-style: normal;
  font-weight: 400;
  line-height: ${({ theme }) => theme.typography.pxToRem(26)};
  opacity: 0.8;
  max-width: 428px;
  margin-bottom: ${({ theme }) => theme.typography.pxToRem(32)};
  text-align: center;

  ${({ theme }) => theme.breakpoints.down("md")} {
    font-size: ${({ theme }) => theme.typography.pxToRem(17)};
    line-height: ${({ theme }) => theme.typography.pxToRem(24)};
    margin-bottom: ${({ theme }) => theme.typography.pxToRem(36)};
    z-index: 3;
  }
`

export const Image = styled(CustomImage)`
  position: absolute;
  bottom: -20px;
  z-index: 2;
  width: 110%;
  /* min-height: 411px; */
  left: 0;
  /* img {
    width: 100%;
    object-fit: cover !important;
  } */

  ${({ theme }) => theme.breakpoints.down("md")} {
    bottom: -10px;
  }

  ${({ theme }) => theme.breakpoints.down("sm")} {
    width: 1300px;
    left: -670px;
    bottom: -17px;
  }
`

export const CustomTypeAnimation = styled(TypeAnimation)`
  color: ${({ theme }) => theme.palette.primary.light};
  font-size: ${({ theme }) => theme.typography.pxToRem(72)};
  font-style: normal;
  font-weight: 400;
  line-height: ${({ theme }) => theme.typography.pxToRem(80)};
  margin-bottom: ${({ theme }) => theme.typography.pxToRem(48)};
  margin-top: 0;
  text-align: center !important;

  ${({ theme }) => theme.breakpoints.down("md")} {
    font-size: ${({ theme }) => theme.typography.pxToRem(52)};
    line-height: ${({ theme }) => theme.typography.pxToRem(64)};
    margin-bottom: ${({ theme }) => theme.typography.pxToRem(24)};
    font-weight: 500;
    margin-top: 0.5rem;
  }
`

export const Button = styled(CustomButton)`
  z-index: 3;
  height: 52px;
`
